<template>
  <v-container grid-list-md fluid>
    <v-card>
      <Edit :editDialog="editDialog" :task="selectedTask" @close="editClose" />
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">My Task</h1>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <h1 class="subheading">{{ task.length }}</h1>
      </v-toolbar>
      <v-card-text v-if="isLoading">
        <v-progress-linear
          size="50"
          width="7"
          indeterminate="indeterminate"
          color="pink"
        ></v-progress-linear>
      </v-card-text>

      <v-list two-line v-if="!isLoading">
        <template v-for="(row, index) in task">
          <v-list-tile :key="row.id" avatar>
            <v-list-tile-avatar>
              <v-checkbox
                hide-details
                @change="complateTask(row)"
                class="mt-0"
                :key="row.id"
                v-model="row.isComplete"
              ></v-checkbox>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <span :class="{ linethrough: row.isComplete }">{{
                  row.title
                }}</span></v-list-tile-title
              >
              <v-list-tile-sub-title class="text--primary">
                <span>{{ row.createdAt | moment("from", "now") }}</span>
                <span v-if="row.dueDate">
                  | <span class="red--text"> {{ row.dueDate | moment("from", "now") }}</span>
                </span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>{{ row.description }}</v-list-tile-sub-title>
              <!-- <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title> -->
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon @click="editTask(row)">
                <v-icon>mdi-eye-outline</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 < task.length" :key="index"></v-divider>
        </template>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
// import dashbaordService from '../service.js'
const Edit = () => import("./Edit");
import { mapGetters } from "vuex";
import taskService from "../service";

export default {
  data() {
    return {
      selectedTask: {},
      editDialog: false,
      task: [],
      isLoading: true,
      updateInfo: false,
    };
  },
  // mounted() {
  // },
  computed: {
    ...mapGetters("location", ["location"]),
    ...mapGetters("global", ["currentUser"])
  },
  mounted() {
    this.getAll();
    this.$events.listen("refresh-task", data => this.reset());
  },
  components: {
    Edit
  },
  methods: {
    editClose() {
      this.selectedTask = {};
      this.editDialog = !this.editDialog;
    },
    complateTask(data) {
      return taskService.update(data.id, { isComplete: data.isComplete });
    },
    async reset() {
      await this.getAll();
    },
    editTask(row) {
      this.selectedTask = row;
      this.editDialog = !this.editDialog;
    },
    getAll() {
      return taskService
        .getAllByStore(this.location.storeID)
        .then(result => {
          this.task = result.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.log("error is ..", error);
        });
    }
  }
};
</script>

<style scoped>
.linethrough {
  text-decoration: line-through;
}
</style>
